import {
  EsriWMTSLayer,
  EsriMapImageLayer,
  EsriTileLayer,
  EsriFeatureLayer,
  EsriWMSLayer,
  EsriVectorTileLayer,
} from '../../config/esri.module';
import { LayerConfig } from '../../config/model/layer-config.model';

export class LayerFactory {
  public static createLayer(layerConfig: LayerConfig): any {
    let layer: any;
    switch (layerConfig.type) {
      case 'wms':
        layer = new EsriWMSLayer(layerConfig.properties);
        break;
      case 'wmts':
        layer = new EsriWMTSLayer(layerConfig.properties);
        break;
      case 'tile':
        layer = new EsriTileLayer(layerConfig.properties);
        break;
      case 'map-image':
        layer = new EsriMapImageLayer(layerConfig.properties);
        break;
      case 'feature':
        this.checkFeatureLayerConfig(layerConfig);
        layer = new EsriFeatureLayer(layerConfig.properties);
        break;
      case 'vector-tile':
        layer = new EsriVectorTileLayer(layerConfig.properties);
        break;
      default:
        throw Error('layerConfig from type ${layerConfig.type} is not supported');
    }

    return layer;
  }

  private static checkFeatureLayerConfig(layerConfig: LayerConfig) {
    // check of feature service
    if (layerConfig.properties.url.indexOf('FeatureServer') === -1) {
      throw new Error(
        'layerConfig.porperties.url from type "feature" must point to a FeatureServer'
      );
    }
  }
}
